import { produce } from 'immer';

var initialState = {
  url_data: {},
  current_url: null,
  loading: false,
  error: false,
  status: 'INITIATED'
};
var reducer = function reducer(state, _ref, _ref2) {
  var type = _ref.type,
    payload = _ref.payload,
    error = _ref.error;
  var types = _ref2.types,
    statuses = _ref2.statuses;
  return produce(state, function (draftState) {
    var _draftState$url_data;
    switch (type) {
      case types.GET_URL_METADATA:
      case types.GET_URLS_METADATA:
        draftState.loading = true;
        draftState.error = initialState.error;
        draftState.status = statuses === null || statuses === void 0 ? void 0 : statuses.LOADING;
        break;
      case types.GET_URL_METADATA_SUCCESS:
        draftState.loading = initialState.loading;
        draftState.current_url = payload.data;
        draftState.status = statuses === null || statuses === void 0 ? void 0 : statuses.READY;
        var linkUrl = payload.linkUrl,
          data = payload.data;
        if (!((_draftState$url_data = draftState.url_data) !== null && _draftState$url_data !== void 0 && _draftState$url_data[linkUrl])) {
          var _Object$assign;
          draftState.url_data = Object.assign({}, draftState.url_data, (_Object$assign = {}, _Object$assign[linkUrl] = data, _Object$assign));
        }
        break;
      case types.GET_URLS_METADATA_SUCCESS:
        draftState.loading = initialState.loading;
        draftState.current_url = initialState.current_url;
        draftState.status = statuses === null || statuses === void 0 ? void 0 : statuses.READY;
        payload.forEach(function (urlData) {
          var _draftState$url_data2;
          var linkUrl = urlData.linkUrl,
            data = urlData.data;
          if (!((_draftState$url_data2 = draftState.url_data) !== null && _draftState$url_data2 !== void 0 && _draftState$url_data2[linkUrl])) {
            var _Object$assign2;
            draftState.url_data = Object.assign({}, draftState.url_data, (_Object$assign2 = {}, _Object$assign2[linkUrl] = data, _Object$assign2));
          }
        });
        break;
      case types.GET_URL_METADATA_ERROR:
      case types.GET_URLS_METADATA_ERROR:
        draftState.current_url = initialState.current_url;
        draftState.loading = initialState.loading;
        draftState.error = error;
        draftState.status = statuses === null || statuses === void 0 ? void 0 : statuses.ERRORED;
        break;
      case types.CLEAR_CURRENT_URL:
        draftState.current_url = initialState.current_url;
        break;
      default:
        return state;
    }
  });
};

export { reducer as default, initialState };
//# sourceMappingURL=reducer.js.map
